import React from 'react';
import 'typeface-roboto';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './Components/App';

const theme = createMuiTheme({
  type: 'dark',
  palette: {
    primary: {
      main: '#191919',
      lighter: '#2c2d2d',
      light: '#e4e3ed'
    },
    secondary: {
      light: '#242525',
      dark: '#B28C36',
      main: '#F8C146'
    },
    background: {
      default: '#191919',
      paper: '#F4F4F7',
      darkPaper: '#E3E3E9',
      white: '#FFFFFF'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#696F89'
    },
    divider: '#696F89'
  },
  typography: {
    useNextVariants: true,
  }
});

export const Root = () => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <App/>
  </MuiThemeProvider>
);
